var _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g10, _path2, _path3, _path4, _path5, _path6, _path7, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamDiscussion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 746,
    height: 544,
    viewBox: "0 0 746 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: 0.0845424,
    d: "M674.32 164.249C683.698 151.73 701.453 149.18 713.979 158.552C726.379 167.83 729.005 185.315 719.957 197.81L719.679 198.187L645.379 297.373C635.916 310.007 618.34 313.21 605.04 304.802L604.639 304.544L557.865 273.948L510.705 342.593C501.937 355.356 484.564 358.693 471.702 350.17L471.313 349.908C458.543 341.146 455.204 323.783 463.732 310.928L463.994 310.539L525.793 220.586C534.999 207.185 553.141 203.492 566.841 212.144L567.255 212.41L614.898 243.574L674.32 164.249Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.0845424,
    d: "M431.118 3.29424C433.496 -0.160162 438.232 -1.03872 441.696 1.33194C445.115 3.67139 446.018 8.30087 443.756 11.7421L443.664 11.8791L425.148 38.779C422.433 42.5698 417.181 43.4829 413.345 40.8606L413.208 40.7654L402.574 33.1946L391.048 51.4538C388.839 54.9536 384.234 56.0368 380.696 53.9185L380.557 53.8332C377.047 51.6305 375.96 47.0392 378.085 43.5109L378.17 43.3722L393.455 19.158C395.973 15.169 401.257 13.9705 405.258 16.4812L405.467 16.6168L405.673 16.7584L416.53 24.4883L431.118 3.29424Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    opacity: 0.070266,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.403 129.308C634.783 129.308 635.903 128.189 635.903 126.808V108.831H653.892C655.272 108.831 656.392 107.711 656.392 106.331V97.676C656.392 96.2952 655.272 95.176 653.892 95.176H635.903V77.0663C635.903 75.6856 634.783 74.5663 633.403 74.5663H624.607C623.227 74.5663 622.107 75.6856 622.107 77.0663V95.176H604.118C602.737 95.176 601.618 96.2952 601.618 97.676V106.331C601.618 107.711 602.737 108.831 604.118 108.831H622.107V126.808C622.107 128.189 623.227 129.308 624.607 129.308H633.403Z",
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    opacity: 0.0739397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6025 20C143.194 20 184.206 60.9886 184.206 111.551C184.206 162.113 143.194 203.101 92.6025 203.101C42.011 203.101 0.998535 162.113 0.998535 111.551C0.998535 60.9886 42.011 20 92.6025 20ZM92.6025 65.3034C67.046 65.3034 46.3283 86.0089 46.3283 111.551C46.3283 137.092 67.046 157.798 92.6025 157.798C118.159 157.798 138.877 137.092 138.877 111.551C138.877 86.0089 118.159 65.3034 92.6025 65.3034Z",
    fill: "#00CFE8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Meeting"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5962 101C61.5962 92.1634 68.7596 85 77.5962 85H547.725C556.561 85 563.725 92.1634 563.725 101V305.224C563.725 314.061 556.561 321.224 547.725 321.224H77.5962C68.7597 321.224 61.5962 314.061 61.5962 305.224V101Z",
    fill: "#E7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    opacity: 0.383371,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.147 101C69.147 92.1634 76.3104 85 85.147 85H547.724C556.561 85 563.725 92.1634 563.725 101V305.224C563.725 314.061 556.561 321.224 547.725 321.224H85.147C76.3104 321.224 69.147 314.061 69.147 305.224V101Z",
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6978 102.559C76.6978 97.0364 81.1749 92.5592 86.6978 92.5592H546.174C551.697 92.5592 556.174 97.0364 556.174 102.559V303.665C556.174 309.188 551.697 313.665 546.174 313.665H86.6978C81.1749 313.665 76.6978 309.188 76.6978 303.665L76.6978 102.559Z",
    fill: "#E7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.85 299.823C275.85 296.509 278.536 293.823 281.85 293.823H351.021C354.335 293.823 357.021 296.509 357.021 299.823V313.665H275.85V299.823Z",
    fill: "#D4EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    d: "M283.401 299.823C283.401 296.509 286.087 293.823 289.401 293.823H358.572C361.886 293.823 364.572 296.509 364.572 299.823V321.225H283.401V299.823Z",
    fill: "#91D6FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ElementCard20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    filter: "url(#filter0_dd_2_884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8555 107.397C90.8555 104.421 93.2681 102.008 96.2442 102.008H221.268C224.244 102.008 226.657 104.421 226.657 107.397V148.047C226.657 151.023 224.244 153.436 221.268 153.436H96.2442C93.2681 153.436 90.8555 151.023 90.8555 148.047V107.397Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    opacity: 0.454078,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.036 132.559C131.036 131.716 131.72 131.032 132.564 131.032H157.991C158.835 131.032 159.519 131.716 159.519 132.559C159.519 133.403 158.835 134.087 157.991 134.087H132.564C131.72 134.087 131.036 133.403 131.036 132.559Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.036 123.903C131.036 123.059 131.72 122.375 132.564 122.375H147.819C148.663 122.375 149.346 123.059 149.346 123.903C149.346 124.747 148.663 125.431 147.819 125.431H132.564C131.72 125.431 131.036 124.747 131.036 123.903Z",
    fill: "#8478FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.812 120.284C207.982 117.43 212.052 116.877 214.903 119.049C215.559 119.549 216.114 120.169 216.538 120.876C216.757 121.241 216.638 121.714 216.274 121.933C215.91 122.151 215.438 122.033 215.219 121.668C214.896 121.129 214.472 120.655 213.972 120.274C211.841 118.651 208.818 119.022 207.139 121.085L207.036 121.216L204.651 124.353C200.926 129.254 194.623 131.414 188.692 129.849L188.438 129.779L186.52 129.237C186.396 129.202 186.272 129.171 186.146 129.143C182.638 128.369 179.167 130.541 178.308 134.011L178.268 134.182L177.872 135.98C177.732 136.617 177.461 137.217 177.075 137.742C175.55 139.817 172.632 140.262 170.558 138.735C170.216 138.483 170.143 138.001 170.395 137.659C170.646 137.316 171.128 137.243 171.47 137.495C172.859 138.518 174.814 138.22 175.836 136.829C176.062 136.521 176.23 136.175 176.331 135.808L176.37 135.649L176.766 133.851C177.734 129.451 182.082 126.67 186.477 127.639L186.708 127.694L186.937 127.755L188.856 128.297C194.171 129.799 199.856 127.946 203.271 123.622L203.427 123.421L205.812 120.284Z",
    fill: "#8478FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.881 119.353C200.452 115.857 204.556 114.297 208.049 115.869C208.751 116.184 209.395 116.615 209.955 117.143C211.275 118.384 212.496 120.347 213.641 123.035C213.808 123.426 213.626 123.878 213.236 124.045C212.845 124.212 212.393 124.03 212.226 123.639C211.157 121.13 210.042 119.338 208.902 118.264C208.465 117.854 207.964 117.519 207.418 117.273C204.75 116.072 201.622 117.22 200.353 119.838L200.284 119.985L199.789 121.086C199.674 121.343 199.542 121.591 199.393 121.83C197.566 124.766 193.707 125.664 190.774 123.834C190.425 123.616 190.042 123.458 189.64 123.366C187.689 122.919 185.744 124.102 185.23 126.022L185.196 126.157L184.34 129.899C184.082 131.026 183.535 132.067 182.752 132.917C180.312 135.571 176.214 135.785 173.512 133.434L173.369 133.305L169.882 130.092C169.57 129.804 169.55 129.317 169.838 129.004C170.106 128.712 170.548 128.675 170.859 128.906L170.924 128.959L174.411 132.173C176.484 134.084 179.712 133.95 181.621 131.875C182.176 131.271 182.577 130.543 182.791 129.754L182.841 129.555L183.697 125.813C184.344 122.985 187.159 121.217 189.984 121.865C190.48 121.979 190.957 122.165 191.4 122.416L191.587 122.527C193.799 123.907 196.71 123.23 198.088 121.016C198.163 120.896 198.232 120.773 198.295 120.646L198.387 120.455L198.881 119.353Z",
    fill: "#C7C1FF"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 113.489,
    cy: 128.231,
    rx: 10.4267,
    ry: 10.4383,
    fill: "#8478FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard3"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    filter: "url(#filter1_dd_2_884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8555 165.592C90.8555 162.83 93.094 160.592 95.8555 160.592H254.805C257.566 160.592 259.805 162.83 259.805 165.592V298.271C259.805 301.033 257.566 303.271 254.805 303.271H95.8555C93.094 303.271 90.8555 301.033 90.8555 298.271V165.592Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 160,
    width: 170,
    height: 144
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8555 165.592C90.8555 162.83 93.094 160.592 95.8555 160.592H254.805C257.566 160.592 259.805 162.83 259.805 165.592V298.271C259.805 301.033 257.566 303.271 254.805 303.271H95.8555C93.094 303.271 90.8555 301.033 90.8555 298.271V165.592Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path 3",
    filter: "url(#filter2_d_2_884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.508 270.2C113.508 270.2 133.593 264.426 142.449 252.639C151.305 240.853 154.291 229.428 169.522 229.428C184.754 229.428 186.706 246.926 203.172 246.926C219.638 246.926 220.538 224.612 226.011 215.752C231.483 206.892 240.928 206.892 240.928 206.892",
    stroke: "#8EEAF6",
    strokeWidth: 4.004,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 3_2",
    opacity: 0.414737,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.508 268.982C113.508 268.982 133.593 263.232 142.449 251.497C151.305 239.761 154.291 228.386 169.522 228.386C184.754 228.386 186.706 245.808 203.172 245.808C219.638 245.808 220.538 223.591 226.011 214.769C231.483 205.947 240.928 205.947 240.928 205.947V280.349C240.928 282.05 239.549 283.429 237.848 283.429H116.588C114.887 283.429 113.508 282.05 113.508 280.349V268.982Z",
    fill: "#CEF9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    x: 104.069,
    y: 174.765,
    width: 52.8556,
    height: 5.66939,
    rx: 2.83469,
    fill: "#8EEAF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.069 191.773C104.069 190.208 105.338 188.939 106.904 188.939H125.775C127.34 188.939 128.609 190.208 128.609 191.773C128.609 193.339 127.34 194.608 125.775 194.608H106.904C105.338 194.608 104.069 193.339 104.069 191.773Z",
    fill: "#8EEAF6",
    fillOpacity: 0.401934
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    cx: 227.242,
    cy: 178.072,
    rx: 3.30348,
    ry: 3.30714,
    fill: "#8EEAF6",
    fillOpacity: 0.451705
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    cx: 236.68,
    cy: 178.072,
    rx: 3.30348,
    ry: 3.30714,
    fill: "#8EEAF6",
    fillOpacity: 0.451705
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_5",
    cx: 246.119,
    cy: 178.072,
    rx: 3.30348,
    ry: 3.30714,
    fill: "#8EEAF6",
    fillOpacity: 0.451705
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ElementCard11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13",
    filter: "url(#filter3_d_2_884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.232 122.721C286.232 118.588 289.583 115.237 293.717 115.237H518.929C523.063 115.237 526.414 118.588 526.414 122.721V273.237C526.414 277.37 523.063 280.721 518.929 280.721H293.717C289.583 280.721 286.232 277.37 286.232 273.237V122.721Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.851 200.101V259.287H318.021V200.101H326.851Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.851 214.245V259.287H318.021V214.245H326.851Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.851 242.533V259.287H318.021V242.533H326.851Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.044 185.957V259.287H339.213V185.957H348.044Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.044 207.173V259.287H339.213V207.173H348.044Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.044 242.533V259.287H339.213V242.533H348.044Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.236 196.565V259.287H360.406V196.565H369.236Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.236 217.781V259.287H360.406V217.781H369.236Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.236 246.068V259.287H360.406V246.068H369.236Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.429 178.885V259.287H381.599V178.885H390.429Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.429 200.101V259.287H381.599V200.101H390.429Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.429 228.389V259.287H381.599V228.389H390.429Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.621 164.741V259.287H402.791V164.741H411.621Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.621 193.029V259.287H402.791V193.029H411.621Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.621 235.461V259.287H402.791V235.461H411.621Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.814 185.957V259.287H423.983V185.957H432.814Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.814 207.173V259.287H423.983V207.173H432.814Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.814 239.704V259.287H423.983V239.704H432.814Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.006 193.029V259.287H445.176V193.029H454.006Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.006 207.173V259.287H445.176V207.173H454.006Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.006 234.753V259.287H445.176V234.753H454.006Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.198 178.885V259.287H466.368V178.885H475.198Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.198 207.173V259.287H466.368V207.173H475.198Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.198 241.825V259.287H466.368V241.825H475.198Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.391 193.029V259.287H487.561V193.029H496.391Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.391 207.173V259.287H487.561V207.173H496.391Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.391 241.825V259.287H487.561V241.825H496.391Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    opacity: 0.57573,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.195 145.646C315.195 144.475 316.145 143.525 317.317 143.525H387.954C389.125 143.525 390.075 144.475 390.075 145.646C390.075 146.818 389.125 147.768 387.954 147.768H317.317C316.145 147.768 315.195 146.818 315.195 145.646Z",
    fill: "#8C81FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    x: 315.195,
    y: 131.502,
    width: 39.5593,
    height: 4.2432,
    rx: 2.1216,
    fill: "#8478FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Chair4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.039 449.882L570.482 540.29L564.483 540.21L553.04 450.728L559.039 449.882Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.616 464.093C476.4 464.093 472.171 459.864 472.171 454.648C472.171 449.431 476.4 445.203 481.616 445.203H519.378C525.1 445.203 529.882 440.849 530.418 435.153L536.456 370.96C536.991 365.263 541.773 360.91 547.495 360.91H571.195C577.654 360.91 582.745 366.408 582.25 372.848L576.026 453.854C575.582 459.632 570.765 464.093 564.971 464.093H481.616Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.173 454.567C472.225 454.568 472.277 454.568 472.329 454.568H555.459C561.252 454.568 566.069 450.108 566.514 444.332L572.734 363.614C572.801 362.734 572.765 361.872 572.635 361.038C572.083 360.954 571.518 360.91 570.941 360.91H547.353C541.632 360.91 536.851 365.262 536.314 370.957L530.281 434.916C529.743 440.611 524.962 444.963 519.242 444.963H481.592C476.389 444.963 472.171 449.181 472.171 454.384C472.171 454.445 472.171 454.506 472.173 454.567Z",
    fill: "#BFE7FF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.275 345.34C558.473 342.498 559.276 325.746 550.002 319.935C559.566 299.875 537.449 279.958 522.299 292.241C512.367 287.987 504.113 304.586 513.355 317.478C509.48 339.613 517.367 345.335 531.583 345.578L546.275 345.34Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.123 341.339C546.123 341.339 540.189 339.946 539.983 330.217C539.778 320.489 539.922 317.169 539.922 317.169L526.852 316.933C526.852 316.933 526.709 327.774 526.707 331.696C526.702 342.229 519.367 341.339 519.367 341.339C519.367 341.339 520.891 349.88 532.735 350.546C541.982 351.067 546.123 341.339 546.123 341.339Z",
    fill: "url(#paint0_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.969 312.311C548.799 312.085 547.848 320.625 541.791 320.614C541.791 320.614 538.273 332.746 526.059 332.746C516.14 332.746 515.495 318.606 515.405 315.785C515.308 312.777 515.296 302.896 515.296 302.896L543.196 302.883L542.969 312.311Z",
    fill: "url(#paint1_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M528.414 324.596C528.414 324.596 525.505 327.06 522.135 324.752",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M526.494 327.45C525.588 327.868 524.717 327.898 523.939 327.481",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M542.374 316.904C542.314 315.534 542.732 314.446 544.128 314.227",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.891 311.256C543.891 311.256 540.695 315.546 540.048 315.569C539.401 315.592 539.174 309.989 539.174 309.989C535.253 309.689 525.332 307.712 522.9 303.107C521.199 307.171 517.948 308.975 515.811 308.629L515.406 317.262L514.409 299.906H544.673L543.891 311.256Z",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.403 512.891C486.403 512.891 491.634 523.462 487.346 526.793C483.052 530.125 471.708 536.368 471.708 536.368L501.761 534.478L495.081 511.424L486.403 512.891Z",
    fill: "url(#paint2_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.854 522.951C497.371 523.125 498.955 528.121 495.744 528.501C492.539 528.88 490.981 524.147 487.345 525.647C483.708 527.148 470.444 534.906 469.922 538.078C469.393 541.249 474.335 542.182 481.112 541.466C487.889 540.75 489.138 538.337 494.226 539.309C499.307 540.28 503.113 538.732 502.946 535.017C502.778 531.303 500.337 522.778 498.854 522.951Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.686 526.417L486.346 527.407C486.669 527.893 486.51 528.551 486.001 528.835L477.036 533.841C476.745 534.003 476.392 534.01 476.095 533.86L474.704 533.153C476.889 531.569 478.677 530.379 480.652 529.21C482.169 528.313 483.847 527.388 485.686 526.417Z",
    fill: "white",
    fillOpacity: 0.540975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.676 419.725C522.577 420.131 471.938 431.338 462.737 433.242C453.537 435.146 445.758 445.448 452.774 457.377C460.654 470.768 480.985 508.799 485.922 517.373C488.365 521.616 500.691 519.237 497.795 512.115C492.398 498.838 489.892 465.485 476.131 453.324C476.131 453.324 522.408 461.382 542.397 452.152C556.925 445.442 553.639 418.742 531.676 419.725Z",
    fill: "url(#paint3_linear_2_884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.209 365.893C467.209 365.893 467.312 358.486 464.722 354.615C462.132 350.744 462.03 346.632 460.07 346.766C458.11 346.901 460.051 356.458 460.051 356.458C460.051 356.458 457.564 355.508 455.777 354.306C453.991 353.103 448.574 347.176 447.308 348.226C445.162 350.016 448.619 360.111 450.502 362.129C452.391 364.148 462.711 370.787 462.711 370.787L467.209 365.893Z",
    fill: "url(#paint4_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.122 361.454C518.89 371.276 511.14 389.32 507.945 394.703C503.942 401.444 497.628 404.414 490.236 399.413C482.469 394.157 461.082 373.657 460.454 369.014C459.833 364.37 465.068 358.799 469.804 361.683C474.541 364.568 494.222 380.956 494.222 380.956C494.222 380.956 502.165 360.583 508.555 348.782C514.089 338.572 529.565 346.523 523.122 361.454Z",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.14 380.966C494.14 380.966 492.007 388.206 491.508 387.787C491.009 387.368 491.889 379.074 491.889 379.074L494.14 380.966Z",
    fill: "black",
    fillOpacity: 0.302803
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.42 349.62C565.42 349.62 555.221 383.791 554.919 390.259C554.617 396.728 563.261 415.74 561.789 420.545C558.396 431.65 515.072 436.431 513.417 421.493C512.645 414.526 514.252 408.273 512.401 400.064C510.556 391.855 503.142 379.657 507.347 368.188C511.553 356.719 510.426 346.109 513.434 344.103C516.441 342.098 523.472 339.968 523.472 339.968C526.891 345.002 538.434 344.929 543.942 339.613C543.942 339.613 557.625 342.269 565.42 349.62Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.281 355.154C549.482 365.949 549.502 384.745 545.851 387.206C542.2 389.668 527.988 387.252 527.988 389.202C527.988 391.151 547.627 409.016 544.403 417.557C542.715 422.029 543.173 426.029 545.777 429.559L546.627 429.373C554.365 427.624 560.586 424.482 561.789 420.545C563.261 415.74 553.62 396.728 553.922 390.259C554.178 384.768 562.285 359.316 564.729 351.748C562.739 348.234 559.923 349.37 556.281 355.154Z",
    fill: "black",
    fillOpacity: 0.199355
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.687 383.794C544.687 383.794 536.096 376.187 533.466 375.304C530.836 374.421 515.434 373.36 515.531 375.355C515.642 377.493 523.914 377.37 524.771 378.421C525.629 379.472 525.823 386.659 529.064 387.465C532.297 388.272 541.992 389.663 541.992 389.663L544.687 383.794Z",
    fill: "url(#paint5_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.542 351.583C576.593 364.364 584.321 383.833 587.287 391.423C590.253 399.013 587.261 410.462 574.218 408.214C561.198 405.973 540.483 393.792 538.191 390.239C535.899 386.686 539.381 380.221 543.766 381.067C547.828 381.85 567.979 390.423 567.979 390.423C567.979 390.423 555.015 367.432 551.85 361.269C546.562 350.976 559.57 340.322 567.542 351.583Z",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.773 390.265C567.773 390.265 574.563 393.641 573.735 392.225C572.907 390.81 565.182 385.837 565.182 385.837L567.773 390.265Z",
    fill: "black",
    fillOpacity: 0.302803
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Men3.2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.061 509.194C235.061 509.194 234.925 517.906 240.271 521C245.617 524.095 253.9 529.844 253.9 529.844L222.392 530.913L223.29 509.116L235.061 509.194Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.292 518.794L220.779 532.926H228.098L228.599 531.105C228.599 531.105 231.355 530.992 232.947 531.779C234.63 532.61 234.856 533.014 234.856 533.014L258.07 533.063C258.07 533.063 259.215 528.495 252.139 525.191C245.063 521.887 239.91 517.197 238.932 516.717C237.946 516.233 235.957 515.96 234.556 517.096C233.156 518.232 232.048 521.219 228.874 521.312C224.789 521.433 222.442 516.404 221.292 518.794Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38",
    d: "M241.131 518.25L238.724 520.577",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38_2",
    d: "M244.64 520.014L242.233 522.342",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38_3",
    d: "M248.149 521.779L245.742 524.107",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 321C212 321 220.753 417.38 221.026 424.079C221.298 430.779 218.214 442.342 218.274 454.874C218.334 467.406 219.4 511.575 219.4 511.575L238.71 511.984C238.71 511.984 246.825 432.167 246.913 420.198C247 408.229 247.744 322.152 247.744 322.152L212 321Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    opacity: 0.283552,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.919 427.079L225.94 427.318C226.231 431.404 223.693 444.846 218.327 467.645L218.274 454.874C218.215 442.565 221.189 431.192 221.037 424.443L221.026 424.079C220.934 421.822 219.879 409.379 218.521 393.872L219.155 396.143C222.878 409.595 225.132 419.908 225.919 427.079Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.477 507.966L184.753 530.525L198.481 530.456L198.915 507.613L188.477 507.966Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 517.724C185.656 518.015 184.682 519.182 184.637 520.556L184.526 523.91C182.584 526.064 181.667 532.287 181.57 532.977C181.564 533.02 181.561 533.061 181.565 533.105C181.85 536.154 201.82 536.116 203.694 533.249C203.779 533.118 203.785 532.963 203.76 532.809C203.55 531.538 202.434 525.385 200.289 523.707L200.276 520.384C200.271 519.031 199.361 517.849 198.054 517.498L195.991 516.944C193.984 514.017 191.249 514.121 188.906 517.31L187 517.724Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 39",
    d: "M189.685 519.748H195.242",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 39_2",
    d: "M189.685 522.393H195.242",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 39_3",
    d: "M190.569 525.037H194.359",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.4 322.265C195.4 322.265 189.267 388.331 189.35 400.982C189.433 413.635 191.238 419.191 188.67 428.267C186.101 437.343 183.911 509.786 183.911 509.786L202.902 511.864C202.902 511.864 215.035 434.346 216.354 423.599C217.673 412.851 233.979 321.353 233.979 321.353L195.4 322.265Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    opacity: 0.283552,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.53 367.105L199.371 371.298C195.979 383.673 192.849 396.76 193.668 415.455L193.708 416.309C193.91 420.358 191.334 443.861 185.98 486.816L185.47 489.835C184.945 492.915 184.478 495.542 184.068 497.717L184.184 493.913C184.867 472.914 186.703 435.215 188.67 428.267C191.238 419.191 189.433 413.635 189.35 400.982C189.291 392.126 192.28 357.097 194.078 336.877L195.4 322.265L203.417 322.076L203.436 324.326C203.577 345.099 202.609 359.358 200.53 367.105Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.834 240.566C288.834 240.566 287.249 231.828 287.819 230.058C288.306 228.529 292.908 226.324 292.908 226.324C292.908 226.324 300.912 213.818 302.664 215.091C304.089 216.123 298.496 225.343 298.496 225.343C298.496 225.343 303.596 230.636 303.525 233.002C303.454 235.368 295.2 242.774 295.2 242.774L288.834 240.566Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.08 226.198C293.08 226.198 296.625 225.721 297.189 226.812C297.67 227.742 294.725 230.379 294.725 231.12C294.725 231.861 294.767 237.472 295.004 237.523C295.241 237.574 298.555 228.367 297.848 226.42C297.266 224.821 293.08 226.198 293.08 226.198Z",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.546 251.684C237.26 243.662 223.317 258.124 238.865 271.569C244.796 276.699 263.428 289.493 267.995 292.307C275.266 296.785 281.241 292.744 283.697 285.697C285.78 279.723 298.238 247.743 296.653 243.046C295.619 239.982 290.071 237.001 287.285 239.412C283.215 242.935 270.766 273.839 270.766 273.839C270.766 273.839 257.103 260.805 246.546 251.684Z",
    fill: "#877BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.766 273.839C270.766 273.839 274.843 278.786 275.138 278.03C275.432 277.275 271.904 270.918 271.904 270.918L270.766 273.839Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 41",
    d: "M286.204 241.393C289.444 239.893 292.983 241.748 294.933 244.724",
    stroke: "#5386BF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.741 242.431C206.741 242.431 212.079 241.203 212.265 232.628C212.45 224.053 212.32 221.126 212.32 221.126L224.976 220.918C224.976 220.918 225.103 230.474 225.106 233.931C225.11 241.457 230.811 243.49 230.811 243.49C230.811 243.49 230.338 251.718 219.683 252.306C211.364 252.765 206.741 242.431 206.741 242.431Z",
    fill: "#F8C5C5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.251 211.881L235.968 219.986C238.36 217.23 239.975 213.814 240.454 209.432L236.251 211.881Z",
    fill: "url(#paint6_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.158 216.791C205.912 216.592 206.768 224.12 212.217 224.11C212.217 224.11 218.073 235.654 227.267 235.683C231.696 235.698 233.142 231.831 234.47 229.116C235.797 226.401 236.772 222.34 236.853 219.853C236.94 217.202 236.951 208.493 236.951 208.493L210.954 208.481L211.158 216.791Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.951 212.489H218.668C218.476 215.728 217.378 218.417 214.592 220.401C214.671 225.146 216.29 228.6 219.098 231.023C221.542 224.155 236.495 226.034 235.407 230.515C233.122 239.929 211.707 240.142 213.006 218.476C212.152 217.334 209.097 217.12 208.091 218.262C206.373 213.529 207.106 206.832 212.074 205.864C208.174 195.777 261.196 193.643 236.951 212.489Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M225.236 230.099C225.236 230.099 227.618 231.815 230.754 229.939",
    stroke: "#CC6969",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_2",
    d: "M211.976 221.089C212.03 219.881 211.654 218.922 210.398 218.729",
    stroke: "#DE6767",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.089 241L224.191 250.796L231.001 242.887C231.001 242.887 245.348 247.327 248.009 252.518C251.85 260.008 246.79 320.022 248.996 323.643C253.696 331.36 247.447 336.658 226.757 338.604C206.067 340.55 187.711 338.957 191.042 328.658C194.374 318.359 181.519 251.147 192.852 247.445C196.393 246.288 209.089 241 209.089 241Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.897 259.529C199.811 261.144 199.34 266.737 197.482 276.309C195.9 284.464 197.709 292.899 202.487 299.705L202.755 300.081C204.371 302.311 205.86 305.247 207.223 308.889C210.567 317.82 202.855 325.266 208.765 339.239L208.05 339.205C196.454 338.606 188.79 335.623 191.042 328.658C193.774 320.214 185.624 273.51 188.846 254.921C194.426 256.015 197.776 257.551 198.897 259.529Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.089 241L222.598 249.795C220.618 252.093 219.556 254.766 219.155 257.709C213.963 253.656 208.566 247.992 206.894 241.902L209.089 241Z",
    fill: "#5E54C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.259 249.566C227.543 251.109 229.365 253.839 230.849 256.944C232.627 253.376 233.308 248.664 233.308 243.639L231.077 242.759L225.259 249.566Z",
    fill: "#5E54C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.598 249.794L222.774 249.893C223.584 250.344 224.594 250.211 225.259 249.566C230.352 268.207 233.934 288.724 235.017 309.576L229.702 318.39L223.485 310.141C224.295 288.47 224.289 267.339 222.598 249.794Z",
    fill: "#CBC6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Example Book Back"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    d: "M236.082 296.99C236.229 295.598 237.504 294.607 238.889 294.81L251.195 296.609C252.503 296.8 253.427 297.99 253.289 299.304L251.081 320.318C250.934 321.71 249.659 322.701 248.274 322.499L235.968 320.7C234.66 320.509 233.736 319.319 233.874 318.004L236.082 296.99Z",
    fill: "#6182EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.548 296.567C237.699 295.128 239.052 294.128 240.472 294.407L253.34 296.93L262.144 296.783C263.623 296.758 264.791 298.033 264.636 299.504L262.431 320.486C262.301 321.724 261.267 322.671 260.022 322.692L250.615 322.849L237.317 320.241C236.065 319.995 235.207 318.834 235.341 317.565L237.548 296.567Z",
    fill: "#96EFFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    d: "M239.873 301.487C239.97 300.561 240.835 299.913 241.752 300.081L247.657 301.161C248.48 301.312 249.048 302.071 248.961 302.902L248.709 305.297C248.612 306.223 247.746 306.871 246.83 306.703L240.924 305.622C240.102 305.472 239.534 304.713 239.621 303.881L239.873 301.487Z",
    fill: "#74CFDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    d: "M252.357 297.631C252.403 297.192 252.797 296.873 253.236 296.919L253.753 296.974C254.192 297.02 254.511 297.414 254.465 297.853L251.917 322.097C251.871 322.536 251.477 322.855 251.038 322.809L250.521 322.755C250.081 322.708 249.762 322.315 249.809 321.875L252.357 297.631Z",
    fill: "#EAEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20",
    d: "M253.059 297.705C253.106 297.266 253.499 296.947 253.939 296.993L254.456 297.048C254.895 297.094 255.214 297.487 255.168 297.927L252.62 322.171C252.573 322.61 252.18 322.929 251.74 322.883L251.223 322.828C250.784 322.782 250.465 322.389 250.511 321.949L253.059 297.705Z",
    fill: "#7AD2DD"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.89 306.414C222.89 306.414 227.476 305.498 229.353 304.033C231.23 302.569 236.915 301.534 236.915 301.534L235.096 305.34C235.096 305.34 249.028 304.04 249.358 305.406C249.689 306.771 245.659 308.256 245.659 308.256C245.659 308.256 243.672 311.944 241.748 314.082C239.928 316.105 230.884 315.864 227.714 314.602C224.975 313.511 221.996 314.056 221.996 314.056L222.89 306.414Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.001 253.239C190.983 242.542 208.042 249.749 203.743 261.209C199.579 272.31 189.489 298.23 189.489 298.23C189.489 298.23 221.461 302.263 223.954 304.144C227.279 306.653 225.224 313.813 222.397 315.088C220.006 316.166 202.244 316.796 184.866 315.435C176.268 314.762 169.91 311.092 169.023 301.559C168.402 294.883 181.202 263.544 186.001 253.239Z",
    fill: "#877BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.501 298.224C189.501 298.224 186.844 303.243 187.603 303.345C188.363 303.448 192.224 298.591 192.224 298.591L189.501 298.224Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 40",
    d: "M221.703 303.599C222.689 306.727 221.996 310.395 220.629 312.988",
    stroke: "#5386BF",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Vase2"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3633 443.346C94.6293 439.634 104.337 443.361 107.996 451.65L110.859 458.135C102.593 461.847 92.8852 458.12 89.2259 449.831L86.3633 443.346Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1742 447.302C106.424 453.172 111.773 459.714 114.238 466.926C116.715 474.173 117.73 486.321 117.269 503.347C117.262 503.61 117.468 503.83 117.729 503.837C117.991 503.844 118.209 503.637 118.216 503.373C118.68 486.241 117.657 473.996 115.133 466.614C112.598 459.197 107.122 452.5 98.7201 446.521C98.5064 446.369 98.211 446.421 98.0603 446.636C97.9095 446.852 97.9605 447.15 98.1742 447.302Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.489 439.32C148.354 435.494 138.66 439.022 134.887 447.182L131.673 454.133C139.808 457.959 149.502 454.431 153.275 446.271L156.489 439.32Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    d: "M91.4976 423.385C99.3415 421.718 107.052 426.725 108.719 434.569L110.069 440.919C102.225 442.586 94.5146 437.579 92.8473 429.735L91.4976 423.385Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2663 428.452C103.312 432.672 107.401 437.223 109.546 442.099L109.678 442.406L109.811 442.729C112.009 448.185 115.647 462.475 120.707 485.545C120.763 485.802 121.016 485.966 121.272 485.91C121.527 485.854 121.688 485.599 121.632 485.342L121.005 482.496L120.273 479.202C115.702 458.761 112.42 446.281 110.412 441.715C108.189 436.662 103.983 431.981 97.8039 427.667C97.5885 427.517 97.2935 427.571 97.1451 427.787C96.9966 428.004 97.0509 428.301 97.2663 428.452Z",
    fill: "#02B596"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.624 418.56C135.979 418.408 128.848 425.294 128.698 433.94L128.565 441.653C137.21 441.805 144.341 434.919 144.49 426.273L144.624 418.56Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.95 421.662C133.389 429.822 129.326 437.699 126.762 445.293C124.203 452.874 121.65 464.581 119.099 480.424C119.058 480.684 119.233 480.93 119.491 480.972C119.749 481.014 119.992 480.837 120.034 480.577L120.348 478.651L120.563 477.353C122.929 463.186 125.296 452.6 127.658 445.601C130.193 438.095 134.216 430.295 139.731 422.203C139.879 421.985 139.824 421.688 139.609 421.539C139.393 421.389 139.098 421.444 138.95 421.662Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.905 416.316C126.905 416.316 122.395 429.164 120.401 448.089C118.408 467.013 119.571 485.938 119.571 485.938L121.772 486.138C121.772 486.138 120.59 464.05 122.009 448.172C123.429 432.294 128.005 416.416 128.005 416.416L126.905 416.316Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6",
    cx: 129.201,
    cy: 409.952,
    rx: 7.26372,
    ry: 11.1372,
    transform: "rotate(14 129.201 409.952)",
    fill: "#C2FFF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_7",
    cx: 129.347,
    cy: 410.625,
    rx: 5.05298,
    ry: 7.26093,
    transform: "rotate(14 129.347 410.625)",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.725 417.005L132.783 404.341C133.024 403.588 132.614 402.781 131.868 402.538C131.122 402.294 130.321 402.707 130.08 403.46L126.022 416.124C125.781 416.877 126.19 417.685 126.937 417.928C127.683 418.171 128.484 417.758 128.725 417.005Z",
    fill: "url(#paint7_linear_2_884)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 87_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.951 403.586C104.951 403.586 110.779 415.892 114.74 434.505C118.7 453.117 119.522 472.06 119.522 472.06L117.354 472.489C117.354 472.489 116.221 450.399 113.149 434.756C110.078 419.113 103.867 403.801 103.867 403.801L104.951 403.586Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8",
    rx: 7.26372,
    ry: 11.1372,
    transform: "matrix(-0.939693 0.34202 0.34202 0.939693 102.002 397.496)",
    fill: "#C2FFF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9",
    rx: 5.05298,
    ry: 7.26093,
    transform: "matrix(-0.939693 0.34202 0.34202 0.939693 101.927 398.181)",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.212 404.462L97.8528 392.291C97.5342 391.568 97.8571 390.722 98.574 390.402C99.291 390.082 100.13 390.409 100.449 391.132L105.808 403.303C106.127 404.026 105.804 404.872 105.087 405.192C104.37 405.512 103.531 405.185 103.212 404.462Z",
    fill: "url(#paint8_linear_2_884)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.019 441.348C140.792 445.742 132.963 450.819 128.537 456.599C124.11 462.378 121.186 471.341 119.743 483.49C119.712 483.752 119.897 483.99 120.157 484.021C120.417 484.053 120.652 483.866 120.683 483.604C122.107 471.611 124.981 462.803 129.286 457.183C133.59 451.563 141.281 446.575 152.362 442.239C152.606 442.143 152.727 441.867 152.632 441.621C152.537 441.375 152.263 441.253 152.019 441.348Z",
    fill: "#02B596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 151",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.929 476.595C116.598 457.598 95.5464 463.157 95.5464 463.157C95.5464 463.157 111.308 468.308 119.346 476.595H121.929Z",
    fill: "#02B596"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path 151_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.875 473.677C127.205 454.68 144.974 457.458 144.974 457.458C144.974 457.458 134.182 466.329 124.458 473.677H121.875Z",
    fill: "#02B596"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path 151_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.836 477.453C117.07 460.599 128.187 446.092 128.187 446.092C128.187 446.092 127.623 466.052 123.76 476.222L121.836 477.453Z",
    fill: "#02B596"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path 114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.173 473.677C115.066 467.587 112.97 459.082 111.399 450.837C119.162 453.959 121.656 466.397 119.162 473.677H117.173Z",
    fill: "#02D3AF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 89"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.022 469.762C101.919 468.584 102.848 467.571 104.03 467.571H134.682C135.865 467.571 136.794 468.584 136.691 469.762L130.784 537.355C130.693 538.396 129.821 539.195 128.775 539.195H109.937C108.892 539.195 108.02 538.396 107.929 537.355L102.022 469.762Z",
    fill: "#7569EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 467,
    width: 35,
    height: 73
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.022 469.762C101.919 468.584 102.848 467.571 104.03 467.571H134.682C135.865 467.571 136.794 468.584 136.691 469.762L130.784 537.355C130.693 538.396 129.821 539.195 128.775 539.195H109.937C108.892 539.195 108.02 538.396 107.929 537.355L102.022 469.762Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4092 463.099H110.354C102.332 493.552 126.479 514.488 110.354 544.941H97.4092V463.099Z",
    fill: "#8175FF"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Chair4_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.746 449.882L668.303 540.29L674.303 540.21L685.746 450.728L679.746 449.882Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.447 449.882L635.004 540.29L641.003 540.21L652.446 450.728L646.447 449.882Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.494 449.882L730.937 540.29L724.938 540.21L713.495 450.728L719.494 449.882Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.071 464.093C636.854 464.093 632.625 459.864 632.625 454.648C632.625 449.431 636.854 445.203 642.071 445.203H679.833C685.555 445.203 690.337 440.849 690.872 435.153L696.91 370.96C697.446 365.263 702.228 360.91 707.949 360.91H731.65C738.108 360.91 743.2 366.408 742.705 372.848L736.481 453.854C736.037 459.632 731.219 464.093 725.425 464.093H642.071Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.627 454.567C632.679 454.568 632.731 454.568 632.783 454.568H715.913C721.707 454.568 726.524 450.108 726.969 444.332L733.188 363.614C733.256 362.734 733.22 361.872 733.089 361.038C732.538 360.954 731.972 360.91 731.396 360.91H707.807C702.087 360.91 697.305 365.262 696.768 370.957L690.735 434.916C690.198 440.611 685.416 444.963 679.696 444.963H642.046C636.843 444.963 632.625 449.181 632.625 454.384C632.625 454.445 632.626 454.506 632.627 454.567Z",
    fill: "#BFE7FF"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Wom2.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.109 511.415C644.109 511.415 649.355 522.01 645.054 525.349C640.747 528.688 629.371 534.946 629.371 534.946L659.511 533.052L652.811 509.944L644.109 511.415Z",
    fill: "url(#paint9_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.525 521.003C655.576 521.455 657.136 525.712 653.799 525.413C650.463 525.115 648.368 520.714 645.908 521C643.447 521.285 641.885 525.717 637.2 528.803C632.517 531.89 625.572 535.572 626.037 538.675C626.502 541.779 637.431 542.61 642.968 541.582C648.505 540.556 651.089 538.33 654.681 538.507C658.273 538.685 660.531 538.245 661.657 535.939C662.782 533.632 657.619 520.48 656.525 521.003Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.259 535.167L655.952 535.149C651.5 534.774 648.446 537.574 644.209 538.363C639.971 539.153 628.795 539.426 627.01 536.775C626.926 536.65 626.847 536.521 626.774 536.391C626.175 537.128 625.892 537.917 626.037 538.836C626.503 541.789 637.432 542.58 642.97 541.603C648.507 540.626 651.091 538.507 654.684 538.676L655.322 538.7C658.546 538.788 660.602 538.294 661.66 536.232C661.918 535.729 661.86 534.649 661.601 533.283C660.099 534.311 658.202 535.226 656.259 535.167Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.511 418.032C680.387 418.439 629.601 429.672 620.375 431.58C611.148 433.488 603.347 443.814 610.383 455.772C618.285 469.194 638.675 507.314 643.626 515.907C646.076 520.16 658.437 517.775 655.534 510.636C650.121 497.329 647.607 463.898 633.807 451.709C633.807 451.709 680.217 459.786 700.264 450.534C714.833 443.808 711.537 417.047 689.511 418.032Z",
    fill: "#413C75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.859 361.074C625.859 361.074 625.963 355.65 623.365 351.77C620.768 347.89 620.665 343.768 618.7 343.903C616.734 344.038 618.68 353.618 618.68 353.618C618.68 353.618 616.187 352.665 614.395 351.46C612.604 350.255 607.171 344.314 605.901 345.367C603.749 347.16 607.216 357.279 609.104 359.302C610.999 361.326 620.348 366.98 620.348 366.98L647.883 394.719L652 379.993L625.859 361.074Z",
    fill: "url(#paint10_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.933 358.625C676.689 368.47 668.917 386.556 665.713 391.951C661.698 398.708 655.366 401.686 647.953 396.672C646.402 395.623 641.947 391.954 641.947 391.954C642.606 385.532 645.006 380.164 649.142 375.849L651.95 378.172C651.95 378.172 659.916 357.752 666.324 345.924C671.874 335.69 687.394 343.659 680.933 358.625Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.868 378.183C651.868 378.183 649.729 385.44 649.229 385.019C648.728 384.599 649.611 376.286 649.611 376.286L651.868 378.183Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.278 320.411V329.123L705.675 323.972C705.675 323.972 707.641 315.626 709.24 309.427C710.243 305.539 712.686 292.384 702.85 293C694.793 278.796 671.327 287.587 671.14 304.94C670.915 325.811 671.099 333.937 671.099 333.937C684.368 334.698 691.837 332.78 699.278 320.411Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.813 336.997C705.813 336.997 699.862 335.6 699.656 325.85C699.449 316.099 699.594 312.77 699.594 312.77L686.486 312.534C686.486 312.534 686.343 323.401 686.341 327.332C686.336 336.889 679.307 337.672 679.307 337.672C679.307 337.672 680.509 345.558 692.386 346.225C701.66 346.748 705.813 336.997 705.813 336.997Z",
    fill: "url(#paint11_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.65 307.901C708.497 307.675 707.544 316.235 701.469 316.224C701.469 316.224 697.941 328.384 685.692 328.384C675.744 328.384 675.097 314.211 675.007 311.383C674.91 308.369 674.897 298.465 674.897 298.465L702.878 298.452L702.65 307.901Z",
    fill: "url(#paint12_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.103 307.845C700.679 308.245 700.973 309.849 700.314 309.709C696.968 308.997 683.424 309.936 681.68 302.488C679.51 307.141 678.98 308.285 674.202 309.534V295.899L704.423 293C704.423 293 703.954 307.704 703.103 307.845Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    d: "M688.054 320.215C688.054 320.215 685.136 322.685 681.757 320.372",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    d: "M686.128 323.076C685.22 323.494 684.346 323.525 683.566 323.107",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_3",
    d: "M702.054 312.505C701.994 311.132 702.413 310.041 703.813 309.822",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.484 336C697.016 340.574 688.382 342.251 680.345 337.284C667.23 363.146 663.961 394.002 667.116 428.106C686.241 435.678 702.315 434.189 716 425.535L704.484 336Z",
    fill: "#FFE4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.415 511.84C611.415 511.84 611.574 524.311 601.298 528.974C591.028 533.635 583.712 533.355 584.643 536.959C585.574 540.563 612.304 540.418 614.801 537.599C616.928 535.201 621.555 512.872 622.829 514.579L611.415 511.84Z",
    fill: "url(#paint13_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.879 529.452C617.304 528.319 615.98 534.853 611.703 533.036C607.425 531.219 610.798 525.213 608.106 524.105C605.414 522.998 600.216 528.953 593.312 530.401C586.408 531.848 580.803 533.114 579.21 535.801C577.838 538.111 579.21 538.849 579.21 538.849C579.21 538.849 585.856 542.168 589.986 542.899C595.986 543.96 613.325 544.667 615.225 542.732C616.392 541.545 619.667 530.019 618.879 529.452Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.835 536.073C577.534 538.196 579.588 539.3 579.834 539.422L580.824 539.844C582.705 540.626 586.946 542.302 590.081 542.901C595.829 544 613.629 544.651 615.543 542.762C615.88 542.43 616.295 541.217 616.698 539.641L615.476 539.774C609.598 540.397 596.478 541.524 590.002 539.998C584.255 538.644 581.108 536.417 579.674 535.117C579.325 535.416 579.043 535.734 578.835 536.073Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.102 414.177C718.102 414.177 731.368 442.192 712.725 451.812C694.696 461.115 640.724 450.112 640.724 450.112C640.724 450.112 641.689 457.877 640.724 464.802C638.206 482.889 626.226 513.023 623.692 516.809C620.187 522.046 609.51 518.097 609.309 513.737C609.107 509.377 617.357 453.693 618.612 443.075C619.86 432.456 623.8 430.913 635.309 428.01C637.953 427.343 669.22 419.573 672.084 419.8C696.695 421.746 718.102 414.177 718.102 414.177Z",
    fill: "#524D87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.56 448.921C685.711 450.921 638.456 446.798 636.558 448.671C634.746 450.46 635.049 481.575 630.984 499.585L631.602 497.884C635.425 487.267 639.394 474.354 640.724 464.802C641.689 457.877 640.724 450.112 640.724 450.112L642.901 450.533C653.16 452.46 696.86 459.999 712.725 451.812C721.322 447.376 724.83 440.006 723.249 429.703C720.527 441.349 713.964 447.755 703.56 448.921Z",
    fill: "white",
    fillOpacity: 0.056108
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.157 336.021C691.789 376.538 684.371 433.979 723 423.986C702.48 386.206 730.375 369.202 724.053 349.676C721.891 343 704.319 335.497 704.157 336.021Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.108 352.846C704.129 354.955 715.652 379.362 711.038 383.039C706.424 386.716 698.392 387.113 697.526 389.359C695.785 393.874 704.199 405.271 722.767 423.551L723 423.986C705.126 391.076 723.988 373.931 724.969 357.151C722.898 353.903 720.611 352.468 718.108 352.846Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681 337C676.28 348.838 674.011 358.127 671.894 375.504C670.129 389.976 671.013 419.84 671.013 419.84L665.18 420.987C665.18 420.987 661.01 374.848 662.404 368.907C664.744 358.938 666.329 353.114 669.418 344C671.12 338.998 681 337 681 337Z",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.56 382.017C701.56 382.017 693.944 374.392 691.307 373.507C688.67 372.622 674.223 371.559 674.32 373.559C674.431 375.701 683.728 375.578 684.587 376.632C685.447 377.685 686.642 385.888 689.892 386.697C693.135 387.506 699.857 389.9 699.857 389.9L729.782 405.362L726.594 389.901L701.56 382.017Z",
    fill: "url(#paint14_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.481 349.731C733.558 362.542 741.307 382.056 744.282 389.664C747.257 397.272 744.256 408.747 731.176 406.494C729.618 406.226 727.085 405.24 727.085 405.24C722.275 398.647 721.431 392.987 723.226 387.947L724.918 388.661C724.918 388.661 711.917 365.617 708.743 359.439C703.44 349.122 716.485 338.444 724.481 349.731Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.918 388.661C724.918 388.661 731.522 391.887 730.691 390.468C729.861 389.049 722.403 384.182 722.403 384.182L724.918 388.661Z",
    fill: "black",
    fillOpacity: 0.159856
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Example Ipad1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.967 346.044C586.638 344.724 587.441 343.387 588.762 343.058L612.231 337.206C613.552 336.877 614.889 337.68 615.218 339.001L623.74 373.181C624.069 374.501 623.266 375.838 621.946 376.168L598.476 382.019C597.156 382.348 595.818 381.545 595.489 380.225L586.967 346.044Z",
    fill: "url(#paint15_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.883 346.595C587.554 345.275 588.357 343.938 589.677 343.608L613.147 337.757C614.467 337.428 615.805 338.231 616.134 339.552L624.656 373.732C624.985 375.052 624.181 376.389 622.861 376.718L599.392 382.57C598.071 382.899 596.734 382.096 596.405 380.775L587.883 346.595Z",
    fill: "#518DF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    d: "M588.884 346.896C588.587 345.708 589.311 344.504 590.499 344.208L612.571 338.705C613.759 338.408 614.963 339.131 615.259 340.32L622.964 371.223C623.26 372.411 622.537 373.615 621.349 373.911L599.277 379.414C598.088 379.71 596.885 378.987 596.589 377.799L588.884 346.896Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group 26_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.204 395.871H395.621V540.751H384.204L384.204 395.871Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.375 400.634L362.563 400.634V427.542H287.403V540.751H272.375V400.634Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.792 400.634H279.792V540.751H271.792V400.634Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 25_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.43 400.634H680.43V540.751H664.43V400.634Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.43 395.871H674.43V540.751H664.43L664.43 395.871Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.006 400.634L671.006 400.634V427.19H550.714V540.751H532.006V400.634Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.59 395.871L532.479 395.871V436.101H283.59V395.871Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.771 400.634H538.188V436.101H526.771V400.634Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.042 400.634H541.042V540.751H532.042V400.634Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.476 403.015C533.476 399.07 536.674 395.871 540.62 395.871L685.745 395.871C689.69 395.871 692.889 399.07 692.889 403.015C692.889 406.96 689.69 410.158 685.745 410.158H540.62C536.674 410.158 533.476 406.96 533.476 403.015Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.735 398.729H529.625V413.016H280.735V398.729Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.805 403.015C259.805 399.07 263.003 395.871 266.948 395.871H543.412C547.358 395.871 550.556 399.07 550.556 403.015C550.556 406.96 547.358 410.158 543.412 410.158H266.948C263.003 410.158 259.805 406.96 259.805 403.015Z",
    fill: "#DBDBDB"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Men2.8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RLeg_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.388 505.181L296.49 530.824L313.057 531.425C313.057 531.425 311.186 522.653 313.857 514.43C316 507.829 317.748 504.535 317.748 504.535L304.388 505.181Z",
    fill: "#92691F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.623 524.377C312.623 524.377 318.947 530.238 325.027 532.409C331.108 534.58 333.436 534.604 333.87 535.421L333.948 535.576C335.199 538.159 334.441 541.589 320.58 541.779C317.21 541.825 313.708 539.868 304.409 537.797L303.738 541.417C298.534 541.348 295.497 540.528 294.628 538.956C293.319 536.605 295.545 525.01 297.08 524.791C298.616 524.571 298.919 529.286 303.042 529.39C307.171 529.493 312.623 524.377 312.623 524.377Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.882 532.356C324.694 532.519 324.467 532.691 324.201 532.854C323.277 533.421 321.884 533.872 320.012 533.444C319.06 533.227 318 532.618 316.958 531.852C315.911 531.082 314.862 530.137 313.929 529.221C312.996 528.305 312.176 527.416 311.59 526.755C311.297 526.425 311.062 526.152 310.901 525.961C310.875 525.931 310.851 525.903 310.83 525.877C310.967 525.771 311.099 525.668 311.224 525.568C311.242 525.59 311.261 525.613 311.282 525.638C311.442 525.826 311.674 526.096 311.964 526.423C312.545 527.078 313.357 527.959 314.279 528.865C315.203 529.771 316.234 530.699 317.254 531.449C318.28 532.204 319.273 532.763 320.123 532.957C321.853 533.352 323.113 532.935 323.94 532.428C324.088 532.337 324.223 532.243 324.344 532.15C324.523 532.222 324.702 532.291 324.882 532.356Z",
    fill: "#81411E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.631 424.913C266.631 424.913 332.424 430.174 341.489 430.455C350.554 430.735 357.48 443.674 350.46 455.617C342.576 469.024 321.155 507.621 316.967 516.545C313.425 524.09 297.327 520.998 300.224 509.473C303.682 495.679 310.128 464.733 323.897 452.558C323.897 452.558 290.41 464.699 271.548 452.924C260.787 446.206 266.631 424.913 266.631 424.913Z",
    fill: "#7A3636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.46 455.617L349.435 457.376C345.444 464.271 339.002 475.923 332.85 487.27L333.174 486.23C337.931 471.092 345.323 453.258 348.482 447.817C349.59 445.909 351.098 443.966 353.007 441.985C353.816 446.139 353.201 450.954 350.46 455.617Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.987 505.479C375.987 505.479 380.385 525.038 386.11 527.131C388.314 527.937 369.218 530.238 369.218 530.238L364.424 511.474L375.987 505.479Z",
    fill: "#92691F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.46 523.631L366.141 540.142L372.723 540.191L372.79 536.48C372.79 536.48 377.92 539.556 381.394 540.638C386.066 542.097 404.525 541.333 406.61 539.11C408.696 536.877 408.741 533.324 404.459 532.887C400.178 532.45 393.098 531.15 390.05 528.818C386.363 526.007 384.96 521.547 383.889 521.543C382.25 521.537 382.123 526.784 373.804 526.858C370.637 526.886 366.46 523.631 366.46 523.631Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.186 523.015C382.186 523.015 386.431 529.639 388.955 530.598C391.478 531.547 393.512 530.482 393.512 530.482C393.512 530.482 389.161 528.748 387.48 525.722C383.672 518.867 382.911 522.354 382.186 523.015Z",
    fill: "#81411E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.075 430.227C272.075 430.227 271.983 451.248 286.106 456.532C300.23 461.815 346.22 459.827 346.22 459.827C346.22 459.827 360.814 513.525 364.311 518.755C367.808 523.985 384.39 524.527 383.493 512.481C382.59 500.435 376.119 455.713 374.867 445.107C373.622 434.5 369.69 431.96 358.208 430.06C354.172 429.392 355.885 428.322 329.941 427.107C324.369 426.846 315.02 428.932 306.429 429.877C297.837 430.822 272.075 430.227 272.075 430.227Z",
    fill: "#7A3636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.977 430.681L317.977 428.24L319.127 428.068C323.309 427.447 327.112 426.974 329.941 427.107L332.923 427.252C355.757 428.407 354.333 429.418 358.207 430.06L358.954 430.186C369.616 432.033 373.475 434.614 374.781 444.419L375.146 447.37C376.875 460.962 382.644 501.158 383.493 512.481C383.561 513.387 383.529 514.222 383.412 514.989L380.05 498.062C375.097 472.966 372.321 458.096 371.722 453.452L371.597 452.487C370.479 444.244 367.55 434.016 358.102 434.683L357.285 434.751C350.633 435.258 338.017 433.982 319.437 430.923L317.977 430.681Z",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10",
    cx: 385.32,
    cy: 446.912,
    rx: 3.77561,
    ry: 6.61391,
    transform: "rotate(13 385.32 446.912)",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.263 402.315C282.263 402.315 297.654 405.878 297.498 407.277C297.345 408.682 290.569 408.898 290.569 408.898C290.569 408.898 303.095 416.987 302.098 418.565C301.101 420.143 292.934 421.921 289.545 420.648C286.154 419.375 277.367 410.113 277.367 410.113L282.263 402.315Z",
    fill: "url(#paint16_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.402 356.716C277.247 363.078 259.669 382.513 259.669 382.513C259.669 382.513 277.247 395.033 281.673 397.681C288.932 402.021 281.551 413.536 276.228 412.258C269.014 410.52 250.806 397.959 242.251 392.875C233.695 387.792 236.969 379.584 243.299 372.095C248.161 366.343 258.732 354.557 266.169 344.211C273.569 333.917 292.406 344.37 282.402 356.716Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.67 382.513C259.67 382.513 254.721 387.281 255.235 387.65C255.75 388.019 261.713 383.979 261.713 383.979L259.67 382.513Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.094 310.007C317.417 310.48 317.111 318.089 311.848 318.486C310.773 325.821 306.937 329.315 302.261 329.719L302.52 340.813L281.834 340.801C281.834 340.801 287.659 332.964 287.369 322.235C287.079 311.506 287.564 301.427 287.564 301.427L314.356 301.908L313.094 310.007Z",
    fill: "url(#paint17_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.632 289.313C320.569 293.336 313.994 310.328 313.994 310.328C309.179 309.671 304.545 315.514 302.788 321.244C297.707 326.467 291.126 326.458 286.75 323.416C286.75 323.416 280.729 304.793 282.698 298.592C284.668 292.391 290.106 285.647 304.632 289.313Z",
    fill: "#2C272E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.958 343.288C265.527 345.724 264.502 355.536 266.958 394.408C268.229 414.537 262.82 434.376 264.218 443.109C265.616 451.843 275.224 452.886 275.224 452.886L280.827 434.657L283.463 452.886C283.463 452.886 323.196 449.171 326.678 440.125C330.168 431.06 325.786 409.75 324.744 389.683C323.697 369.537 324.482 348.858 322.557 345.724C318.714 339.468 308.822 336.546 302.682 335.61C294.891 334.422 284.834 334.377 278.855 336.273C272.875 338.168 268.388 340.852 266.958 343.288Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.387 357.131C310.523 380.265 314.716 396.498 319.966 405.83C322.137 409.688 324.342 411.279 326.582 410.602L326.05 405.475C325.52 400.287 325.017 394.942 324.744 389.683C324.553 386.016 324.424 382.331 324.327 378.737L307.387 357.131Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.854 336.273C278.492 336.388 278.141 336.507 277.802 336.631C286.387 340.374 300.562 339.874 308.268 336.825C306.26 336.258 304.335 335.862 302.682 335.61C294.891 334.422 284.834 334.377 278.854 336.273Z",
    fill: "#E5AA41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.154 377.168C384.154 377.168 396.939 368.633 399.198 366.919C401.45 365.212 404.277 352.268 402.525 350.452C401.679 349.573 395.283 355.486 394.142 356.278C393.008 357.062 387.209 360.556 387.209 360.556C387.209 360.556 388.85 350.648 387.437 349.849C386.392 349.268 384.301 351.818 384.022 354.513C383.742 357.207 380.835 360.723 380.46 364.812C380.29 366.599 378.531 370.013 378.531 370.013L384.154 377.168Z",
    fill: "url(#paint18_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.014 360.801C312.913 370.98 321.233 385.863 325.803 394.589C331.211 404.915 337.655 409.29 350.652 401.628C361.537 395.211 377.233 384.89 385.343 379.281C392.89 374.061 383.969 361.175 376.839 365.529C367.38 371.297 343.193 382.728 343.193 382.728C343.193 382.728 330.746 359.991 325.578 349.075C319.004 335.201 298.533 341.101 308.014 360.801Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.194 382.728C343.194 382.728 345.47 390.744 346.007 390.427C346.544 390.111 345.63 381.579 345.63 381.579L343.194 382.728Z",
    fill: "black",
    fillOpacity: 0.159856
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Chair8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.768 461.221L281.325 542.179L287.324 542.1L298.767 462.067L292.768 461.221Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.93 461.221L342.373 542.179L336.374 542.1L324.931 462.067L330.93 461.221Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.883 461.221L246.44 542.179L252.439 542.1L263.882 462.067L257.883 461.221Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.306 465.983C340.523 465.983 344.751 461.754 344.751 456.538C344.751 451.321 340.523 447.093 335.306 447.093H297.544C291.822 447.093 287.04 442.739 286.505 437.043L280.467 372.85C279.931 367.153 275.149 362.8 269.427 362.8H245.727C239.269 362.8 234.177 368.298 234.672 374.738L240.896 455.744C241.34 461.522 246.157 465.983 251.952 465.983H335.306Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.75 456.457C344.698 456.458 344.646 456.458 344.594 456.458H292.611C286.817 456.458 282 451.998 281.555 446.222L275.248 364.363C278.192 366.121 280.266 369.21 280.609 372.847L286.642 436.806C287.179 442.501 291.961 446.853 297.681 446.853H335.331C340.534 446.853 344.751 451.071 344.751 456.274C344.751 456.335 344.751 456.396 344.75 456.457Z",
    fill: "#91D6FF"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Front Laptop3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.981 394.543C558.981 394.13 558.647 393.796 558.235 393.796H474.099C473.686 393.796 473.352 394.13 473.352 394.543V395.639C473.352 396.052 473.686 396.386 474.099 396.386H558.235C558.647 396.386 558.981 396.052 558.981 395.639V394.543Z",
    fill: "url(#paint19_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.989 394.543C558.989 394.13 558.655 393.796 558.243 393.796H525.916C525.504 393.796 525.169 394.13 525.169 394.543V395.639C525.169 396.052 525.504 396.386 525.916 396.386H558.243C558.655 396.386 558.989 396.052 558.989 395.639V394.543Z",
    fill: "#518DF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.093 358.353C565.368 356.201 563.692 354.296 561.522 354.296H505.711C503.899 354.296 502.37 355.642 502.14 357.439L497.989 389.852C497.713 392.004 499.39 393.909 501.56 393.909H557.371C559.182 393.909 560.712 392.563 560.942 390.766L565.093 358.353Z",
    fill: "#518DF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.394 358.353C563.67 356.201 561.993 354.296 559.823 354.296H505.192C503.38 354.296 501.851 355.642 501.621 357.439L497.47 389.852C497.194 392.004 498.871 393.909 501.041 393.909H555.672C557.484 393.909 559.013 392.563 559.243 390.766L563.394 358.353Z",
    fill: "url(#paint20_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_47",
    d: "M561.445 359.821C561.693 357.884 560.184 356.17 558.231 356.17H506.473C504.842 356.17 503.466 357.381 503.259 358.999L499.519 388.236C499.271 390.173 500.78 391.887 502.733 391.887H554.491C556.122 391.887 557.498 390.675 557.705 389.058L561.445 359.821Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Wom3.8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.644 404.22C424.644 404.22 438.245 407.393 438.107 408.638C437.972 409.89 431.984 410.082 431.984 410.082C431.984 410.082 443.053 417.285 442.172 418.69C441.291 420.095 434.074 421.678 431.079 420.545C428.082 419.412 420.317 411.164 420.317 411.164L398.53 399.463L405.812 389.859L424.644 404.22Z",
    fill: "url(#paint21_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.767 363.617C420.211 369.282 404.678 386.588 404.678 386.588L407.744 388.889L397.772 400.985C397.772 400.985 391.404 397.083 389.285 395.815C381.724 391.288 384.617 383.98 390.211 377.311C394.508 372.189 403.849 361.695 410.421 352.482C416.961 343.316 433.608 352.624 424.767 363.617Z",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 15_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.678 386.588C404.678 386.588 400.305 390.833 400.759 391.162C401.214 391.491 406.483 387.893 406.483 387.893L404.678 386.588Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.126 387.623L394.128 400.491L400.627 404.744L409.556 389.459L407.126 387.623Z",
    fill: "#FFEDC2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.635 503.233L441.604 525.882L453.422 526.413C453.422 526.413 451.756 518.665 454.134 511.403C456.041 505.572 457.598 502.663 457.598 502.663L448.635 503.233Z",
    fill: "url(#paint22_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.518 519.78C453.518 519.78 453.271 525.546 455.285 527.369C457.298 529.19 467.978 535.917 468.873 537.272C469.768 538.628 468.455 540.283 468.455 540.283C468.455 540.283 457.551 541.993 452.407 539.354C448.694 537.448 446.041 535.891 446.041 535.891L444.901 538.82L438.947 537.965C438.947 537.965 437.112 533.316 437.9 531.004C438.689 528.692 442.758 517.889 442.758 517.889C442.758 517.889 453.518 519.78 453.518 519.78Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.248 426.031C423.137 426.898 466.921 437.326 475.936 439.178C484.951 441.03 492.573 451.051 485.698 462.654C477.977 475.679 456.15 516.158 456.15 516.158C456.015 516.191 455.883 516.249 455.747 516.249C451.307 516.249 447.349 515.641 443.538 512.985C443.538 512.985 449.329 470.54 462.812 458.712C462.812 458.712 427.994 471.231 410.582 457.571C400.31 449.513 404.452 425.075 414.248 426.031Z",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.574 442.255L480.183 472.278C480.38 471.928 480.574 471.582 480.767 471.24L483.045 442.636C482.89 442.506 482.733 442.379 482.574 442.255Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.095 501.444C514.095 501.444 517.972 518.714 523.018 520.562C524.961 521.273 511.032 523.305 511.032 523.305L506.807 506.737L514.095 501.444Z",
    fill: "url(#paint23_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.257 518.544L512.935 540.165L519.311 539.157L518.524 533.811C518.524 533.811 521.32 538.468 524.439 538.267C527.567 538.065 543.209 535.707 543.209 535.707C543.209 535.707 543.561 530.529 536.366 529.346C530.381 528.363 520.176 516.809 520.176 516.809L509.257 518.544Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.705 423.171C421.705 423.171 408.874 450.35 426.906 459.682C444.346 468.707 490.749 457.063 490.749 457.063C490.749 457.063 489.816 464.596 490.749 471.314C493.186 488.861 505.168 510.449 506.258 514.007C506.807 515.798 520.171 513.151 520.171 511.026C520.171 508.901 513.352 460.537 512.139 450.236C510.931 439.934 507.12 438.438 495.987 435.622C493.43 434.975 460.284 427.436 457.513 427.656C433.707 429.544 421.705 423.171 421.705 423.171Z",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.513 427.656C460.284 427.436 493.43 434.975 495.987 435.621L497.815 436.091C507.31 438.575 510.83 440.428 512.052 449.547L512.381 452.165C513.384 459.804 516.092 477.769 518.234 492.725C515.816 487.228 513.816 481.129 512.231 474.427C508.54 458.807 509.33 445.982 508.338 443.736C507.347 441.49 458.859 434.32 450.527 432.84C446.901 432.196 444.855 430.599 444.39 428.048C448.417 428.161 452.791 428.031 457.513 427.656Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.203 318.877C455.055 319.299 454.782 326.08 450.093 326.434C449.134 332.97 445.716 336.084 441.549 336.444L441.78 346.331L423.348 346.32C423.348 346.32 428.538 339.336 428.28 329.775C428.021 320.213 428.453 311.231 428.453 311.231L452.327 311.66L451.203 318.877Z",
    fill: "url(#paint24_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.041 319.385C447.555 317.609 444.241 325.257 440.808 330.573C437.375 335.888 428.481 334.985 427.255 330.573C422.615 320.908 418.615 307.769 424.031 306.691C424.793 292.723 461.308 296.021 452.041 319.385Z",
    fill: "#9E5229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.017 301.156H434.93H435.042L435.116 301.239C442.145 309.095 443.719 320.664 440.435 331.099C440.181 331.427 439.904 331.727 439.609 332.001C443.288 321.471 441.878 309.618 434.818 301.656H426.429C426.616 301.483 426.813 301.316 427.017 301.156Z",
    fill: "black",
    fillOpacity: 0.199355
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_11",
    rx: 4.4008,
    ry: 4.40615,
    transform: "matrix(-1 0 0 1 431.868 301.406)",
    fill: "#FB9934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.709 348.001C459.79 353.987 466.591 374.303 466.976 378.873C467.411 384.145 461.751 392.544 461.658 400.176C461.575 407.809 465.879 426.915 464.586 429.062C463.303 431.209 420.69 443.621 418.289 442.601C415.889 441.581 407.602 430.581 409.495 426.11C411.399 421.64 419.265 411.499 418.365 405.408C417.475 399.318 412.307 376.836 409.741 369.184C407.186 361.532 408.038 353.499 412.808 350.206C415.168 348.577 421.466 343.948 432.682 343.97C443.898 343.991 455.393 347.537 455.709 348.001Z",
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.857 373.966L445.302 359.916L445.308 362.483C445.38 378.33 446.378 386.725 462.975 412.695L462.591 410.048C462.05 406.206 461.631 402.608 461.658 400.176C461.716 395.361 463.991 390.241 465.553 385.793L464.857 373.966Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.045 343.532C443.045 343.532 443.517 346.106 441.451 346.106C439.384 346.106 425.524 346.562 423.647 345.748C421.771 344.934 422.334 343.532 422.334 343.532H443.045Z",
    fill: "#FFF6E1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.124 378.86C512.124 378.86 523.411 371.328 525.406 369.815C527.394 368.309 529.889 356.885 528.342 355.283C527.595 354.507 521.949 359.725 520.942 360.424C519.941 361.116 514.821 364.2 514.821 364.2C514.821 364.2 516.27 355.456 515.022 354.751C514.1 354.238 512.254 356.488 512.008 358.866C511.761 361.244 509.194 364.347 508.863 367.956C508.713 369.533 508.129 371.576 508.129 371.576L476.814 385.025L480.09 399.648L512.124 378.86Z",
    fill: "url(#paint25_linear_2_884)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.907 364.416C449.231 373.4 456.577 386.534 460.611 394.235C465.385 403.349 471.074 407.21 482.548 400.448C483.891 399.656 486.796 397.892 486.796 397.892L479.692 382.12L475.964 383.768C475.964 383.768 464.975 363.701 460.413 354.067C454.609 341.822 436.537 347.03 444.907 364.416Z",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.964 383.768C475.964 383.768 477.973 390.842 478.447 390.563C478.921 390.283 478.114 382.753 478.114 382.753L475.964 383.768Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.591 381.423L484.539 401.058L491.901 397.078L482.241 379.894L479.591 381.423Z",
    fill: "#FFEDC2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.339 298.15C432.339 298.15 428.191 292.84 423.401 294.233C418.61 295.626 414.277 304.165 416.334 312.191C418.381 320.219 416.693 324.797 414.21 330.207C407.538 344.76 430.636 354 430.636 354C430.636 354 428.834 343.217 432.339 336.705C435.95 329.999 438 321.399 438 316.137C438 306.986 432.339 298.15 432.339 298.15Z",
    fill: "#9E5229"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Chair8_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.657 461.221L443.1 542.179L437.101 542.1L425.658 462.067L431.657 461.221Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.956 461.221L476.399 542.179L470.4 542.1L458.957 462.067L464.956 461.221Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.909 461.221L380.466 542.179L386.466 542.1L397.909 462.067L391.909 461.221Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.333 465.983C474.549 465.983 478.778 461.754 478.778 456.538C478.778 451.321 474.549 447.093 469.333 447.093H431.57C425.849 447.093 421.067 442.739 420.531 437.043L414.493 372.85C413.957 367.153 409.175 362.8 403.454 362.8H379.754C373.295 362.8 368.203 368.298 368.698 374.738L374.923 455.744C375.367 461.522 380.184 465.983 385.978 465.983H469.333Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.776 456.457C478.724 456.458 478.672 456.458 478.62 456.458H426.637C420.844 456.458 416.027 451.998 415.582 446.222L409.274 364.363C412.218 366.121 414.292 369.21 414.635 372.847L420.668 436.806C421.205 442.501 425.987 446.853 431.707 446.853H469.357C474.56 446.853 478.778 451.071 478.778 456.274C478.778 456.335 478.777 456.396 478.776 456.457Z",
    fill: "#91D6FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2_884",
    x: 70.8555,
    y: 83.0082,
    width: 191.801,
    height: 107.427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0755213 0 0 0 0 0.582569 0 0 0 0 0.878793 0 0 0 0.229458 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_884"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.503982 0 0 0 0 0.700178 0 0 0 0 1 0 0 0 0.233829 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_884",
    result: "effect2_dropShadow_2_884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2_884",
    x: 70.8555,
    y: 141.592,
    width: 224.949,
    height: 198.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0755213 0 0 0 0 0.582569 0 0 0 0 0.878793 0 0 0 0.229458 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_884"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.503982 0 0 0 0 0.700178 0 0 0 0 1 0 0 0 0.233829 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_884",
    result: "effect2_dropShadow_2_884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2_884",
    x: 96.5054,
    y: 202.89,
    width: 161.424,
    height: 97.3126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.144395 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2_884",
    x: 276.232,
    y: 105.237,
    width: 272.181,
    height: 197.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.70188 0 0 0 0 0.70188 0 0 0 0 0.70188 0 0 0 0.208725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_884",
    x1: 554.833,
    y1: 311.939,
    x2: 543.753,
    y2: 361.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_884",
    x1: 553.972,
    y1: 302.545,
    x2: 547.323,
    y2: 335.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_884",
    x1: 506.962,
    y1: 505.352,
    x2: 505.368,
    y2: 535.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_884",
    x1: 475.891,
    y1: 543.704,
    x2: 427.816,
    y2: 451.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_884",
    x1: 470.771,
    y1: 340.915,
    x2: 468.619,
    y2: 369.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_884",
    x1: 549.732,
    y1: 370.46,
    x2: 549.102,
    y2: 388.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_884",
    x1: 242.336,
    y1: 202.269,
    x2: 232.447,
    y2: 203.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D63A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_884",
    x1: 127.011,
    y1: 401.433,
    x2: 127.011,
    y2: 417.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE62BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_884",
    x1: 103.289,
    y1: 388.795,
    x2: 105.021,
    y2: 405.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE62BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_884",
    x1: 664.726,
    y1: 503.858,
    x2: 663.13,
    y2: 533.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_884",
    x1: 660.095,
    y1: 331.529,
    x2: 655.855,
    y2: 392.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_884",
    x1: 714.441,
    y1: 307.528,
    x2: 703.217,
    y2: 357.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_884",
    x1: 713.684,
    y1: 298.112,
    x2: 707.024,
    y2: 330.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_884",
    x1: 629.45,
    y1: 505.061,
    x2: 627.889,
    y2: 538.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_884",
    x1: 739.379,
    y1: 364.401,
    x2: 737.871,
    y2: 403.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_884",
    x1: 586.221,
    y1: 334.275,
    x2: 598.146,
    y2: 382.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_884",
    x1: 291.949,
    y1: 390.304,
    x2: 303.7,
    y2: 416.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_884",
    x1: 322.017,
    y1: 291.839,
    x2: 318.541,
    y2: 338.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_884",
    x1: 407.318,
    y1: 343.095,
    x2: 404.968,
    y2: 375.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_884",
    x1: 552.737,
    y1: 393.207,
    x2: 552.737,
    y2: 396.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_884",
    x1: 559.03,
    y1: 345.282,
    x2: 559.03,
    y2: 393.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_884",
    x1: 422.208,
    y1: 368.874,
    x2: 442.753,
    y2: 415.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_884",
    x1: 460.365,
    y1: 496.881,
    x2: 457.668,
    y2: 525.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_884",
    x1: 526.041,
    y1: 496.123,
    x2: 523.808,
    y2: 522.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_884",
    x1: 459.153,
    y1: 302.686,
    x2: 456.055,
    y2: 344.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_884",
    x1: 537.825,
    y1: 343.73,
    x2: 534.833,
    y2: 397.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamDiscussion);
export default __webpack_public_path__ + "static/media/team-discussion.9fe9eb5cb7c1eea9b62754efc9d57fcf.svg";
export { ForwardRef as ReactComponent };